import React from "react";
import StockNotificationForm from "../../form/StockNotificationForm";
var OOSView = function (_a) {
    var product = _a.product, children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(StockNotificationForm, { pid: product.id, mt: 4, bg: "grays.0", p: 4, onSignup: function () {
                var _a, _b;
                (_b = (_a = window.ONNIT) === null || _a === void 0 ? void 0 : _a.googleTagManager) === null || _b === void 0 ? void 0 : _b.backInStockNoticeRegistered(product.name);
            } }),
        children));
};
export default OOSView;
//# sourceMappingURL=OOSView.js.map